module.exports = __webpack_public_path__ + "media/frontend/svg/artists-123f5919ba31f2680192f5e2b4b78115.svg";